export function isHighlightedClass(classId, highlightClassIds) {
  if (!highlightClassIds?.length || classId == null) return false;
  const id = String(classId);
  return highlightClassIds.some((c) => String(c) === id);
}

/** UI-only row highlight — not used in exports. */
export function highlightRowClass(isHighlighted) {
  return isHighlighted
    ? 'bg-primary-light/70 ring-1 ring-inset ring-primary/30'
    : '';
}

export function stickyCellBg(isHighlighted, fallback = 'bg-card') {
  return isHighlighted ? 'bg-primary-light/70' : fallback;
}
